
export const formFields = {
    existingRO: {
    key: 'existingRO',
    label: 'Existing RO',
    required: true,
    placeholder: '',
    requiredMessage: 'This field is required.',
    displayLayout: 'col-md-12',
    valueKey: 'key',
    textKey: 'value',
    tooltip: '<div> Advertiser </div>'
  },


  dspPlatform: {
    key: 'dspPlatform',
    type: 'text',
    label: 'DSP Platform',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    // minLengthMessage: 'Minimum 3 charactors allowed.',
    maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> DSP Platform </div>',
    // pattern: /^(?=.*?[A-Za-z]).{1,}$/
  },

  campaignName: {
    key: 'campaignName',
    type: 'text',
    label: 'Campaign Name',
    labelLayout: "col-md-12",
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    // minLengthMessage: 'Minimum 3 charactors allowed.',
    maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Campaign Name </div>',
    // pattern: /^(?=.*?[A-Za-z]).{1,}$/
  },

  thumbnailUrl: {
    key: 'thumbnailUrl',
    label: 'Upload ICON Image',
    required: true,
    placeholder: 'Upload ICON Image',
    displayLayout: 'col-md-7',
    uploadRequired: true,
    requiredMessage: 'Upload ICON Image is required.',
    uploadMessage: 'Please Upload ICON Image.',
    tooltip: '<div>Upload ICON Image</div>',
    maxLength: 4000,
    maxLengthMessage: 'maximum 4000 characters allowed.'
  },

  url: {
    key: 'url',
    type: 'file',
    label: 'Creative',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    // minLengthMessage: 'Minimum 3 charactors allowed.',
    maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Creative </div>',
    // pattern: /^(?=.*?[A-Za-z]).{1,}$/
  },
};

export const confirmationMessage = {
  action: {
    confirmationMessage: 'Are You Sure To Map A Campagin With RO?',
    type: 'Confirmation'
  }
}

export const successfullyMessage = {
  action: {
    confirmationMessage: 'Campaign Mapped Successfully.',
    type: 'Success',
  }
}

export const Goal = [
  { key: '1', value: 'CPM' },
  { key: '2', value: 'Clicks' },
  { key: '3', value: 'CPC' },
  { key: '4', value: 'CTR' },
  { key: '5', value: 'VCR' },
  { key: '6', value: 'CPA / CPL' },
  { key: '7', value: 'VTR' },
]

export const roStaus = [
  { key: '1', value: 'Active' },
  { key: '0', value: 'Inactive' },
]